import React from 'react';
import Page from 'src/components/Page';
import SpecLink from 'src/components/SpecLink';
import Table from 'src/components/Table';
import routes from 'src/routes';
import { HashLink as Link } from 'react-router-hash-link';

function TokenPage() {
    return <Page header="2-Party">
        <p>
            There are two, 2-party token management methods.  In this section, the focus is on the 2-party token management without the AuthKey.
            For token processing with an AuthKey, please go to <Link to={routes.api.twoPartyTokenProcessing.root}>2-Party AuthKey</Link>.            
        </p>

        <h2>PCI DSS compliance</h2>
        <p>
            As with all 2-party token processing, you are responsible for meeting PCI-DSS compliance as payment details will be exposed to you.
        </p>

        <h2>Operations</h2>
        <Table
            headers={['Operation', 'Description']}
            body={[
                [<SpecLink uriFragment="#operation/Token_AddToken">Add</SpecLink>, 'Create a new token.'],
                [<SpecLink uriFragment="#operation/Token_GetToken">Read</SpecLink>, 'Using token number, retrieve details about the token.'],
                [<SpecLink uriFragment="#operation/Token_UpdateToken">Update</SpecLink>, 'Update payment details.'],
                [<SpecLink uriFragment="#operation/Token_DeleteToken">Delete</SpecLink>, 'Deletes a token.'],
                [<SpecLink uriFragment="#operation/Token_SearchToken">Search</SpecLink>, 'Search tokens.'],
            ]}
        />
    </Page>;
}

export default TokenPage;
